import styled from 'styled-components';
import { DEVICE } from 'constant/device';
import Drawer from '@material-ui/core/Drawer';

export const TinyMceWrapper = styled.div`
  color: ${(props) => props.textColor};
  ${(props) => (props.maxWidth ? `max-width: ${props.maxWidth}` : ``)};
  width: 100%;
  border-radius: ${(props) => props.borderRadius};
  height: ${(props) => props.height};
  overflow: hidden;

  * {
    outline: none;
  }

  &:focus {
    outline: none;
    ${(props) => props.focusStyle}
  }
`;

export const BaseTextInput = styled.input`
  font-size: ${(props) => props.fontSize};
  font-family: Heebo, sans-serif;
  border: none;
  color: ${(props) => props.textColor};
  background-color: transparent;
  ${(props) => (props.maxWidth ? `max-width: ${props.maxWidth}` : ``)};
  ${(props) => (props.lineHeight ? `line-height:${props.lineHeight};` : '')};
  ${(props) => (props.textAlign ? `text-align:${props.textAlign}` : '')};
  width: 100%;
  padding: 0;
  ${(props) => props.styleForTextInputTypeNumber}
  direction: inherit;

  ::placeholder {
    color: ${(props) => props.placeholderColor};
  }

  &:focus {
    outline: none;
    ${(props) => props.focusStyle}
  }
`;

export const ErrorMsgContainer = styled.div`
  margin-top: 4px;
`;

export const MobileSelectContainer = styled.div``;

export const DrawerSelectContainer = styled.div``;

export const ListIconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 92%;
  padding: 20px;
`;
export const ListTextContainer = styled.div`
  padding: ${({ padding }) => padding};
`;

export const ItemTextContainer = styled.div`
  padding: 14px 0;
  padding-inline-start: 16px;
  min-height: 51px;
  box-sizing: border-box;
`;

export const ListHeaderContainer = styled.div`
  width: 100%;
`;
export const IconContainer = styled.div`
  display: flex;
  align-self: center;
  padding-inline-start: ${(props) => props.paddingInlineStart};
  padding-inline-end: ${(props) => props.paddingInlineEnd};
`;

export const SelectContainer = styled.div`
  width: 100%;

  @media ${DEVICE.xxs} {
    [class*='-control'] {
      padding-inline-start: initial;
    }
  }
`;

export const DrawerContainer = styled(Drawer)`
  .MuiPaper-root {
    height: 100% !important;
    ${(props) => props.isRtl && 'direction: rtl;'}
  }
`;

export const MenuListContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 170px;
  z-index: 1;
  background-color: white;
  position: absolute;
  border-radius: 4px;
  border: solid 1px #f3f3f3;
  box-shadow: 0 4px 3px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(0, 0, 0, 0.05);
  outline: none;
`;

export const MenuContainer = styled.div``;

export const InputContainer = styled.div`
  ${(props) => (props.width ? `width:${props.width};` : 'width: 100%')}
  cursor: ${(props) => props.cursor};
  user-select: ${(props) => props.userSelect};
  pointer-events: ${(props) => props.pointerEvents};
  border: ${(props) => props.borderColor};
  border-radius: ${(props) => props.borderRadius};
  display: flex;
  align-items: center;
`;

export const InputComponentAndError = styled.div`
  display: flex;
  width: ${(props) => (props.width ? props.width : '100%')};
  flex-direction: column;
  border: ${(props) => props.focusStyle};
  border-radius: 4px;
`;

export const TextIconGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-self: baseline;
  width: -webkit-fill-available;
  border: ${(props) => `1px solid ${props.borderColor}`};
  box-sizing: border-box;
  padding: ${(props) => props.padding};
  border-radius: ${(props) => props.borderRadius};
  background-color: ${(props) => props.backgroundColor};
  padding-inline-start: ${(props) => props.paddingInlineStart};
  ${(props) => props.focusStyle};
`;

export const BaseSelectInput = styled.div`
  box-sizing: border-box;
  display: flex;
  height: ${(props) => props.height};
  justify-content: space-between;
  align-items: center;
  cursor: ${(props) => props.cursor} !important;
  font-family: 'arimo';
  line-height: ${(props) => props.lineHeight}px;
  font-size: ${(props) => props.fontSize}px;
  color: ${(props) => props.textColor};
  border-style: solid;
  border-width: 1px;
  background-color: ${(props) => props.backgroundColor};
  border-color: ${(props) => props.borderColor};
  border-radius: ${(props) => props.borderRadius};
  width: ${(props) => props.width};
  padding: ${(props) => props.padding};
  min-height: ${(props) => (props.minHeight ? props.minHeight : '')};
  &:focus {
    outline: none;
  }
`;

export const SelectIconContainer = styled.div`
  display: flex;
  margin-inline-start: ${(props) => props.iconInlineMargin};
`;

export const BaseChipInput = styled.div`
  display: flex;
`;

export const LoadingContainer = styled.div`
  display: ${(props) => props.display};
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  margin: auto;
`;

export const ChipContainer = styled.div`
  display: flex;
  flex-flow: wrap;
  width: 100%;
  position: relative;

  & > :not(:last-child) {
    margin-block-start: 5px;
    margin-inline-end: 15px;
    margin-block-end: 5px;
  }
`;

export const MultiValueContainer = styled.div`
  margin: ${(props) => props.verticalMargin} 0;
  margin-inline-end: ${(props) => props.inlineMargin};
  height: ${(props) => props.height};
`;

export const HTMLIconContainer = styled.div`
  display: flex;
  align-self: center;
  padding-inline-start: 10px;
`;

export const TextInputContainer = styled.div`
  display: flex;
  flex: 1 1 0;
  padding-top: 3px;
`;

export const BaseRadioButton = styled.div`
  border-radius: 50%;
  margin: 3px;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background-color: ${(props) => props.backgroundColor};
`;
export const RadioButtonOutline = styled.div`
  cursor: ${(props) => props.cursor};
  border: ${(props) => props.border};
  border-radius: 50%;
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  display: flex;
  background-color: ${(props) => props.backgroundColor};
`;

export const ValueWrapper = styled.div`
  margin-right: 8px;
  margin-left: 8px;

  & > *:first-child {
    margin-bottom: 5px;
  }
`;

export const RadioButtonContainer = styled.div`
  ${(props) => (props.width ? `width:${props.width}px;` : 'width: fit-content')}
  display:   ${(props) => props.display};
  position: relative;
`;
export const RadioGroupContainer = styled.div`
  display: ${(props) => props.display};
  margin: ${(props) => props.margin};
`;

// export const MenuContainer = styled.div`
//     width: ${props => props.width ? props.width : `100%`};
// `;

export const SelectLabelContainer = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SearchContainer = styled.div`
  display: 'block';
  width: 100%;
  box-sizing: border-box;
  padding-inline-start: 14px;
  padding-inline-end: 4px;
  padding-block-start: 1px;
  padding-block-end: 1px;
  border-bottom: 1px solid ${(props) => props.borderColor};
  border-top: 1px solid ${(props) => props.borderColor};
`;

export const NotFoundWrapper = styled.div`
  display: ${(props) => props.display};
  justify-content: center;
  align-items: center;
  padding: 12px;
`;

export const BaseCanvasContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => (props.bgColor ? props.bgColor : '')};
  align-items: center;
  padding-inline-end: 15px;
  padding-bottom: 25px;
  padding-inline-start: 15px;
`;

export const Canvas = styled.canvas`
  touch-action: none;
`;

export const CanvasActionsConatainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 5px;
  border-top: 1px solid #c2c8cc;
`;

export const PhoneNumberContainer = styled.div`
  display: flex;
  align-self: baseline;
  padding: ${(props) => props.padding};
  border-color: transparent;
  border-radius: 4px;
  background-color: transparent;
  padding-inline-start: 0px;
  width: 100%;

  & > * input {
    outline: none;
    border: none;
    color: ${(props) => props.inputTextColor};
    font-family: arimo, arial;
  }

  .form-control {
    font-size: ${(props) => props.fontSize} !important;
    border: 0px !important;
    background-color: #fff !important;
    padding: 0 14px 0 49px !important;
    box-shadow: initial !important;
    width: 100%;
  }

  .form-control::placeholder {
    font-size: ${(props) => props.fontSize} !important;
    font-family: arimo, arial;
    color: #a6a8ab;
  }

  .special-label {
    display: none !important;
  }
  .arrow {
    box-sizing: border-box !important;
    height: 6px !important;
    width: 6px !important;
    border-style: solid !important;
    border-color: ${(props) => props.arrowColor} !important;
    border-width: 0px 1px 1px 0px !important;
    transform: rotate(45deg) !important;
    margin-top: -2px !important;
  }

  .country-list {
    overflow-x: hidden !important;
    width: 305px !important;
  }

  .selected-flag {
    padding: initial !important;
  }

  @media ${DEVICE.small} {
    .form-control {
      width: 100% !important;
    }
  }
`;

export const BaseTextAreaInput = styled.textarea`
  border: 1px solid ${(props) => props.borderColor};
  border-radius: 5px;
  padding: 7px 24px 8px;
  background-color: #fff;
  min-height: 125px;
`;

export const BaseContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.label`
  margin-bottom: 5px;
  display: flex;
`;

export const AsteriskContainer = styled.div`
  display: ${(props) => props.display};
  justify-content: center;
  align-items: center;
`;

export const ErrorContainer = styled.div`
  display: ${(props) => props.display};
`;

export const LabelWrapper = styled.div``;
